import * as React from "react"

const SvgPuzzle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M8.8 21.429H5q-.824 0-1.413-.588A1.93 1.93 0 0 1 3 19.43v-3.8q1.2 0 2.1-.763.9-.762.9-1.937t-.9-1.938A3.15 3.15 0 0 0 3 10.23v-3.8q0-.825.587-1.413A1.93 1.93 0 0 1 5 4.43h4q0-1.05.725-1.775T11.5 1.93c1.05 0 1.292.241 1.775.725Q14 3.38 14 4.43h4q.824 0 1.413.587Q20 5.605 20 6.43v4q1.05 0 1.775.725t.725 1.775c0 1.05-.242 1.291-.725 1.775q-.725.725-1.775.725v4q0 .825-.587 1.412A1.93 1.93 0 0 1 18 21.43h-3.8q0-1.25-.787-2.125-.789-.876-1.913-.875c-1.124.001-1.387.291-1.912.875q-.788.874-.788 2.125Zm-3.8-2h2.125q.6-1.65 1.925-2.325t2.45-.675 2.45.675 1.925 2.325H18v-6h2a.48.48 0 0 0 .35-.15.48.48 0 0 0 0-.7.48.48 0 0 0-.35-.15h-2v-6h-6v-2a.48.48 0 0 0-.15-.35.48.48 0 0 0-.7 0 .48.48 0 0 0-.15.35v2H5v2.2q1.35.5 2.175 1.675T8 12.929q0 1.425-.825 2.6A4.67 4.67 0 0 1 5 17.229z" />
  </svg>
)
export default SvgPuzzle
